enum IWaveScore {
  WEAK = 1,
  FAIR,
  GOOD,
  STRONG,
}

export default IWaveScore;
